export enum ThemeShade {
    Darker = 0,
    Dark = 1,
    DarkAlt = 2,
    Primary = 3,
    Secondary = 4,
    Tertiary = 5,
    Light = 6,
    Lighter = 7,
    LighterAlt = 8
}

export enum GrayscaleThemeShade {
    White = 0,
    NeutralLighterAlt = 1,
    NeutralLighter = 2,
    NeutralLight = 3,
    NeutralQuaternaryAlt = 4,
    NeutralQuaternary = 5,
    NeutralTertiaryAlt = 6,
    NeutralTertiary = 7,
    NeutralSecondaryAlt = 8,
    NeutralSecondary = 9,
    NeutralPrimaryAlt = 10,
    NeutralPrimary = 11,
    NeutralDark = 12,
    Black = 13,
    WhiteHover = 14,
    NeutralLighterAltHover = 15,
    NeutralLighterHover = 16,
    WhitePressed = 17,
    NeutralLighterAltPressed = 18,
    NeutralLighterPressed = 19,
    WhiteSelected = 20,
    NeutralLighterSelected = 21,
    Disabled = 22
}

export const ThemeRootCssClass = 'ohpAppTheme';
